<template>
	<div class="col-4- mb-2- mt-4-">
		<router-link :to="{ name: 'ThenVsNow', params: { id: id } }">
			<div class="museum-galerij-button mx-auto">
				<div class="h-100 d-flex museum-button-bg-img">
					<div class="background-image" :style="imageThenBackground"></div>
					<div class="background-image background-overlay" :style="imageNowBackground"></div>
					<div class="h-100 w-100 text-overlay">
						<div class="h-100 d-flex">
							<h1 class="m-auto">{{ title }}</h1>
						</div>
					</div>
				</div>
			</div>
			<h1 v-if="total > 1" class="text-center text-dark">{{ total }} <span v-if="total > 1">foto's</span><span v-else>foto</span></h1>
		</router-link>
	</div>
</template>

<script>
export default {
	name: "GalleryOverviewItem",
	props: {
		title: String,
		imageThen: String,
		imageNow: String,
		id: Number,
		total: Number,
	},
	computed: {
		imageThenBackground() {
			return `background-image: url('${this.imageThen}');`;
		},
		imageNowBackground() {
			return `background-image: url('${this.imageNow}');`;
		},
	},
};
</script>

<style scoped>
.background-image {
	position: absolute;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	z-index: -1;
}

.text-overlay {
	background-color: rgba(8, 35, 42, 0.3);
	color: #fff;
}

.text-overlay h1 {
	font-size: 50px;
}

.background-overlay {
	clip-path: polygon(80% 0, 100% 0, 100% 100%, 20% 100%);
	/* clip-path: polygon(35% 0%, 90% 0%, 65% 100%, 10% 100%); */
}
</style>